module.exports = __webpack_public_path__ + "static/media/security.dedc6e3b.svg";